import type { Question } from '@mentimeter/http-clients';

// To be used only in presentation related code, for editor use it from @mentimeter/editor-essentials
export const isTypeQuizSlide = (questionType: Question['type'] | undefined) =>
  Boolean(
    questionType &&
      ['quiz', 'quiz_open', 'quiz_leaderboard'].includes(questionType),
  );
